<template>
  <form @submit.prevent="handleSubmit">
    <div class="eu-mb_5">
      <emd-text class="lable_title">
        {{ $t('title') }}
      </emd-text>
      <emd-text
        size="small"
        tag="p"
        variation-color="subtle"
        class="eu-mt_1"
        >{{ $t('subtle') }}</emd-text
      >
    </div>

    <div class="eu-mb_5">
      <div class="eu-mb_3">
        <emd-text class="lable_title">
          {{ $t('radio-button.title') }}
        </emd-text>
      </div>
      <div>
        <emd-radio
          class="eu-mb_4"
          name="radio-permission-user"
          v-model="scope"
          :value="typeRead"
          :label="$t('radio-button.read-only')"
        />
      </div>
      <div>
        <emd-radio
          class="_bold"
          name="radio-permission-user"
          v-model="scope"
          :value="typeReadWrite"
          :label="$t('radio-button.read-write')"
        />
      </div>
    </div>

    <hr class="emd-divider" />

    <password-confirmation
      class="eu-mt_5"
      label=""
      :has-error="authError"
      v-model="password"
    />

    <div class="create-key__footer">
      <emd-button
        type="outline"
        color="primary"
        data-testid="close-modal"
        @click="handleBack"
      >
        {{ $t('general.back') }}
      </emd-button>

      <emd-button
        color="primary"
        data-testid="create"
        type="submit"
        :disabled="computedDisabled"
      >
        <emd-loader v-if="isLoading"></emd-loader>
        <span v-else> {{ $t('form.button.create') }} </span>
      </emd-button>
    </div>
  </form>
</template>

<script>
import {
  EmdRadio,
  EmdText,
  EmdButton,
  EmdLoader
} from 'emerald-vue/src/components'
import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation.vue'
import { ALL } from '../../enums/secret-keys-scopes.enum'
import { required } from 'vuelidate/lib/validators'
import CREATE_KEY_STEPS_ENUM from '../../enums/create-keys-steps.enum'

export default {
  name: 'AllKey',

  components: {
    EmdRadio,
    EmdText,
    EmdButton,
    PasswordConfirmation,
    EmdLoader
  },

  props: {
    authError: Boolean,
    isLoading: Boolean
  },

  data () {
    return {
      scope: [],
      password: '',
      typeReadWrite: ALL.rw,
      typeRead: ALL.r
    }
  },
  validations: {
    scope: {
      required
    },
    password: {
      required
    }
  },
  computed: {
    computedDisabled () {
      return (
        this.$v.password.$invalid || this.isLoading || this.$v.scope.$invalid
      )
    }
  },
  methods: {
    handleBack () {
      this.$emit('back', CREATE_KEY_STEPS_ENUM.create)
    },
    handleSubmit () {
      this.$emit('submit', {
        password: this.password,
        scope: [this.scope]
      })
    }
  }
}
</script>

<style scoped>
.lable_title {
  font-size: 14px;
  font-weight: 600px;
}
.create-key__footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
</style>

<i18n>
    {
      "pt-BR": {
        "title": "Total",
        "subtle": "Amplo controle sobre operações essenciais da API.",
        "radio-button": {
          "title": "Selecione uma permissão:",
          "read-only": "Somente leitura",
          "read-write": "Leitura e escrita"
        },
        "form.name": "Nome da chave",
        "form.name.placeholder": "Ex.: chave do time de marketing",
        "form.button.create": "Criar chave",
        "form.button.return": "Voltar"
      },
      "en-US": {
        "title": "Total",
        "subtle": "Extensive control over essential API operations.",
        "radio-button": {
          "title": "Select a permission:",
          "read-only": "Only reading",
          "read-write": "Reading and writing"
        },
        "form.name": "Key name",
        "form.name.placeholder": "Name secret key",
        "form.button.create": "CreateKey",
        "form.button.return": "Return"
      }
    }
  </i18n>
